module.exports = __webpack_public_path__ + "img/200_5.d192abfc.png";